import React from 'react';
import { Box } from '@mui/material';
import LegacyReconciliationSummaryTile from './LegacyReconciliationSummaryTile';

type LegacyReconciliationLottoPosTileProps = {
  title: string;
  badge?: 'DEFICIT' | 'MATCHED' | 'SURPLUS';
  value: React.ReactNode;
  subtext?: React.ReactNode;
  footer?: string;
};

const LegacyReconciliationLottoPosTile: React.FC<LegacyReconciliationLottoPosTileProps> = ({
  title,
  badge,
  value,
  subtext,
  footer,
}) => {
  const isDeficit = badge === 'DEFICIT';
  const isMatched = badge === 'MATCHED';

  const tileValue = (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      {badge ? (
        <Box className={isDeficit ? 'deficit-badge' : isMatched ? 'matched-badge' : 'surplus-badge'}>
          {badge}
        </Box>
      ) : null}
      <Box
        sx={{
          color: isDeficit ? '#FF0000 !important' : (isMatched ? '#34C759 !important' : '#0000FF !important'),
          fontSize: title === 'OVERALL' ? '20px' : '14px',
          fontWeight: title === 'OVERALL' ? 700 : 500,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1.4,
        }}
      >
        {value}
      </Box>
    </Box>
  );

  return (
    <LegacyReconciliationSummaryTile
      title={title}
      value={tileValue}
      subtext={subtext}
      footer={footer}
    />
  );
};

export default React.memo(LegacyReconciliationLottoPosTile);
